module.exports = __webpack_public_path__ + "530d4b07aa24944a725b6fa13eb53d66.svg";